import { Form, Spinner } from 'react-bootstrap'
import { InfiniteTable } from '../components/InfiniteTable'
import Meta from '../components/Meta'
import {
  GetFeatureFlagsQuery,
  useGetFeatureFlagsQuery,
  useUpdateFeatureFlagMutation,
} from '../generated/urql.administrator'
import { useCallback, useMemo } from 'react'

const pageTitle = 'Przełączniki funkcji'

const FeatureFlags = () => {
  const [{ data, fetching: isFetching, error }, refetch] =
    useGetFeatureFlagsQuery()
  const [{ fetching: isUpdating }, update] = useUpdateFeatureFlagMutation()

  const onSwitch = useCallback(
    (id: number, isEnabled: boolean) => {
      update({ id, isEnabled }).then(() =>
        refetch({ requestPolicy: 'network-only' })
      )
    },
    [refetch]
  )

  const flags = useMemo(
    () =>
      (data?.feature_flags || []).sort((a, b) => {
        const keyCompare = a.key.localeCompare(b.key)
        if (keyCompare !== 0) return keyCompare
        return (a.project || '').localeCompare(b.project || '')
      }),
    [data?.feature_flags]
  )

  if (isFetching && !flags.length) {
    return (
      <div className="d-flex justify-content-center p-4">
        <Spinner animation="border" />
      </div>
    )
  }

  if (error) {
    return (
      <div className="d-flex justify-content-center p-4">
        Coś poszło nie tak
      </div>
    )
  }

  return (
    <div>
      <Meta title={pageTitle} />
      <InfiniteTable<GetFeatureFlagsQuery['feature_flags'][number]>
        data={flags}
        columns={[
          { Header: 'Klucz', accessor: 'key' },
          { Header: 'Opis', accessor: 'description' },
          { Header: 'Projekt', accessor: 'project' },
          {
            Header: 'Włączona',
            id: 'enabled',
            accessor: (row) => (
              <FlagSwitch
                id={row.id}
                isEnabled={row.enabled}
                isUpdating={isUpdating || isFetching}
                onSwitch={onSwitch}
              />
            ),
          },
        ]}
        loadMoreRows={() => {}}
        hasMore={false}
      />
    </div>
  )
}

type FlagSwitchProps = {
  id: number
  isEnabled?: boolean
  isUpdating: boolean
  onSwitch: (id: number, isEnabled: boolean) => void
}

const FlagSwitch = ({
  id,
  isEnabled = false,
  isUpdating = false,
  onSwitch,
}: FlagSwitchProps) => {
  return (
    <Form className="d-flex align-items-center">
      <Form.Switch
        disabled={isUpdating}
        checked={isEnabled}
        onChange={(e) => {
          e.preventDefault()
          onSwitch(id, !isEnabled)
        }}
      />
    </Form>
  )
}

export default FeatureFlags
